import { mdlServiceResponse } from "../models/service-models/common/ServiceResponse";
import { mdlCopyUserToOtherHotelsRequest } from "../models/service-models/user/CopyUserToOtherHotelsRequest";
import { mdlCopyUserToOtherHotelsResponse } from "../models/service-models/user/CopyUserToOtherHotelsResponse";
import { mdlUserCreateRequest } from "../models/service-models/user/UserCreateRequest";
import { mdlUserCreateResponse } from "../models/service-models/user/UserCreateResponse";
import { mdlUserDeleteRequest } from "../models/service-models/user/UserDeleteRequest";
import { mdlUserDeleteResponse } from "../models/service-models/user/UserDeleteResponse";
import { mdlUserDetailRequest } from "../models/service-models/user/UserDetailRequest";
import { mdlUserDetailResponse } from "../models/service-models/user/UserDetailResponse";
import { mdlUserListRequest } from "../models/service-models/user/UserListRequest";
import { mdlUserListResponse } from "../models/service-models/user/UserListResponse";
import { mdlUserPermissionListRequest } from "../models/service-models/user/UserPermissionListRequest";
import { mdlUserPermissionListResponse } from "../models/service-models/user/UserPermissionListResponse";
import { mdlUserPermissionListUpdateRequest } from "../models/service-models/user/UserPermissionListUpdateRequest";
import { mdlUserPermissionListUpdateResponse } from "../models/service-models/user/UserPermissionListUpdateResponse";
import { mdlUserSetLanguageRequest } from "../models/service-models/user/UserSetLanguageRequest";
import { mdlUserSetLanguageResponse } from "../models/service-models/user/UserSetLanguageResponse";
import { mdlUserUpdateRequest } from "../models/service-models/user/UserUpdateRequest";
import { mdlUserUpdateResponse } from "../models/service-models/user/UserUpdateResponse";
import { GetResponse } from "../utils/ApiClient";

module UserService {
    export async function Create(
        pRequest: mdlUserCreateRequest
    ): Promise<mdlServiceResponse<mdlUserCreateResponse>> {
        return await GetResponse<mdlServiceResponse<mdlUserCreateResponse>>(
            "user/create",
            pRequest
        );
    }
    export async function Update(
        pRequest: mdlUserUpdateRequest
    ): Promise<mdlServiceResponse<mdlUserUpdateResponse>> {
        return await GetResponse<mdlServiceResponse<mdlUserUpdateResponse>>(
            "user/update",
            pRequest
        );
    }
    export async function Delete(
        pRequest: mdlUserDeleteRequest
    ): Promise<mdlServiceResponse<mdlUserDeleteResponse>> {
        return await GetResponse<mdlServiceResponse<mdlUserDeleteResponse>>(
            "user/delete",
            pRequest
        );
    }
    export async function List(
        pRequest: mdlUserListRequest
    ): Promise<mdlServiceResponse<mdlUserListResponse>> {
        return await GetResponse<mdlServiceResponse<mdlUserListResponse>>(
            "user/list",
            pRequest
        );
    }
    export async function Detail(
        pRequest: mdlUserDetailRequest
    ): Promise<mdlServiceResponse<mdlUserDetailResponse>> {
        return await GetResponse<mdlServiceResponse<mdlUserDetailResponse>>(
            "user/detail",
            pRequest
        );
    }

    export async function CopyUserToOtherHotels(
        pRequest: mdlCopyUserToOtherHotelsRequest
    ): Promise<mdlServiceResponse<mdlCopyUserToOtherHotelsResponse>> {
        return await GetResponse<mdlServiceResponse<mdlCopyUserToOtherHotelsResponse>>(
            "user/copy-user-to-other-hotels",
            pRequest
        );
    }
    export async function UserPermissionList(
        pRequest: mdlUserPermissionListRequest
    ): Promise<mdlServiceResponse<mdlUserPermissionListResponse>> {
        return await GetResponse<mdlServiceResponse<mdlUserPermissionListResponse>>(
            "user/user-permission-list",
            pRequest
        );
    }
    export async function PermissionListUpdate(
        pRequest: mdlUserPermissionListUpdateRequest
    ): Promise<mdlServiceResponse<mdlUserPermissionListUpdateResponse>> {
        return await GetResponse<mdlServiceResponse<mdlUserPermissionListUpdateResponse>>(
            "user/user-permission-list-update",
            pRequest
        );
    }
    export async function UserSetLanguage(
        pRequest: mdlUserSetLanguageRequest
    ): Promise<mdlServiceResponse<mdlUserSetLanguageResponse>> {
        return await GetResponse<mdlServiceResponse<mdlUserSetLanguageResponse>>(
            "user/setLanguage",
            pRequest
        );
    }
}

export { UserService };